import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useLanguage } from '@/contexts/LanguageContext';
import PrimaryButton from '@/components/PrimaryButton';
import StageSheetShell, { StagePlaceholderIllustration } from '@/components/StageSheetShell';

interface Props {
  visible: boolean;
  stageNumber: number | null;
  onDismiss: () => void;
}

/**
 * CurrentStageSheet — bottom sheet describing the user's current recovery
 * stage. Triggered from the greeting-row chip on the Missões tab.
 * Visual reference: Figma 6701:51001.
 */
export default function CurrentStageSheet({ visible, stageNumber, onDismiss }: Props) {
  const { t } = useLanguage();

  if (!stageNumber) return null;

  const stageName = t(`recoveryStages.${stageNumber}.name`) as string;
  const stageDescription = t(`recoveryStages.${stageNumber}.description`) as string;
  const headerTitle = (t('currentStage.headerTitle') as string)
    || (t('currentStage.eyebrow') as string)
    || 'Seu estágio';
  const ctaLabel = (t('currentStage.primaryCta') as string) || 'Ok, entendi';

  return (
    <StageSheetShell
      visible={visible}
      title={headerTitle}
      onClose={onDismiss}
      footer={<PrimaryButton title={ctaLabel} onPress={onDismiss} />}
    >
      <View style={styles.illustrationWrap}>
        <StagePlaceholderIllustration />
      </View>
      <Text style={styles.stageName}>{stageName}</Text>
      <Text style={styles.body}>{stageDescription}</Text>
    </StageSheetShell>
  );
}

const styles = StyleSheet.create({
  illustrationWrap: {
    width: 260,
    height: 260,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  stageName: {
    fontFamily: 'Sentient-Regular',
    fontSize: 24,
    lineHeight: 28.8,
    color: '#FFFFFF',
    textAlign: 'center',
    maxWidth: 345,
  },
  body: {
    fontFamily: 'Inter_400Regular',
    fontSize: 14,
    lineHeight: 19.6,
    color: '#FFFFFF',
    textAlign: 'center',
    maxWidth: 345,
    marginTop: 16,
  },
});
